import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { shallow } from 'zustand/shallow';
import { Content, Theme } from '@carbon/react';
import { ChevronRight } from '@carbon/react/icons';
import UpgradeModal from 'src/components/Billing/UpgradeModal';
import { GlobalSearchProvider } from 'src/components/GlobalSearch';
import { useAppStore } from 'src/states/app';
import { ImpersonationBanner } from './ImpersonationBanner';
import MainHeader from './MainHeader';
import { ShellMenuHostProvider } from './ShellMenuHost';

interface MainLayoutProps {}

const MainLayout = React.memo((_: MainLayoutProps) => {
  const { pathname } = useLocation();
  const inSettings = pathname.startsWith('/settings');
  const { theme, fullscreen, sideNavExpanded, setFullscreen } = useAppStore(
    (state) => ({
      theme: state.theme,
      fullscreen: state.fullscreen,
      sideNavExpanded: state.sideNavExpanded,
      setFullscreen: state.setFullscreen,
    }),
    shallow
  );

  useEffect(() => {
    document.body.className = theme === 'dark' ? 'cds--g90' : 'cds--white';
  }, [theme]);

  return (
    <div className={fullscreen ? 'cds--fullscreen' : ''}>
      <GlobalSearchProvider>
        <ImpersonationBanner />
        <Theme theme={theme === 'dark' ? 'g100' : 'g10'}>
          <ShellMenuHostProvider>
            <MainHeader />
          </ShellMenuHostProvider>
        </Theme>
        <Theme theme={theme === 'dark' ? 'g90' : 'white'}>
          <Content
            className={classNames('cds--main-content', {
              'cds--content--with-side-nav-expanded': sideNavExpanded && !inSettings,
            })}
          >
            <Outlet />
            <UpgradeModal />
          </Content>
        </Theme>
        <button type="button" className="fullscreen-toggle" onClick={() => setFullscreen(!fullscreen)}>
          <ChevronRight />
        </button>
      </GlobalSearchProvider>
    </div>
  );
});

export default MainLayout;
